"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutDiagnosticSymbol = exports.LayoutChangeHookSymbol = exports.RenderDoneHookSymbol = exports.LayoutChangeObserverSymbol = exports.RenderDoneObserverSymbol = exports.LayoutDoneServiceSymbol = void 0;
exports.LayoutDoneServiceSymbol = Symbol('LayoutDoneService');
exports.RenderDoneObserverSymbol = Symbol('RenderDoneObserver');
exports.LayoutChangeObserverSymbol = Symbol('LayoutChangeObserver');
exports.RenderDoneHookSymbol = Symbol('RenderDoneHook');
exports.LayoutChangeHookSymbol = Symbol('LayoutChangeHook');
exports.LayoutDiagnosticSymbol = Symbol('LayoutDiagnostic');
//# sourceMappingURL=layoutDone.js.map